<template>
  <div>
    <b-row class="justify-content-md-center">
      <b-col col lg="6">
        <b-alert variant="danger" :show="isRegisterError">{{ $t('register.register_error_feedback') }}</b-alert>
        <b-form @submit="doSubmit" v-if="show">
          <b-form-group
            id="gusername"
            :label="$t('register.username')"
            label-for="username"
            class="required"
            :invalid-feedback="form_invalid_feedback.username"
          >
            <b-form-input
              id="username"
              v-model="form.username"
              type="text"
              autocomplete="username"
              required
              :placeholder="$t('register.username')"
              :state="form_state.username"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="group1"
            :label="$t('register.email')"
            label-for="mailinput"
            class="required"
            :invalid-feedback="form_invalid_feedback.email"
          >
            <b-form-input
              id="mailinput"
              v-model="form.email"
              type="text"
              autocomplete="email"
              required
              :placeholder="$t('register.email')"
              :state="form_state.email"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="group2"
            :label="$t('register.password')"
            label-for="passinput"
            class="required"
            :invalid-feedback="form_invalid_feedback.password"
          >
            <PasswordInput
              id="passinput"
              v-model="form.password"
              required
              autocomplete="new-password"
              :placeholder="$t('register.password')"
              :state="form_state.password"
              @focus="handleOnFocusPassInput()"
            ></PasswordInput>
            <PasswordHelper :password="form.password" :show="show_pass_helper" />
          </b-form-group>

          <b-form-group
            id="group3"
            :label="$t('register.password2')"
            label-for="passinput"
            class="required"
            :invalid-feedback="form_state.password2"
          >
            <PasswordInput
              id="password2"
              v-model="form.password2"
              required
              autocomplete="new-password"
              :placeholder="$t('register.password2')"
              :state="form_state.password2"
              @focus="handleOnFocusPass2Input()"
            ></PasswordInput>
            <b-form-invalid-feedback
              class="text-info"
              :force-show="show_same_pass_helper && !isSamePassword()"
            >{{ $t('register.pass_validator_help_same_password') }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group id="group4" :invalid-feedback="form_state.private">
            <b-form-checkbox
              id="private"
              name="private"
              value="accepted"
              required
              unchecked-value="not_accepted"
            >{{ $t('register.private') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group id="group5" :invalid-feedback="form_state.terms">
            <b-form-checkbox
              id="terms"
              name="terms"
              value="accepted"
              required
              unchecked-value="not_accepted"
            >{{ $t('register.terms') }}</b-form-checkbox>
          </b-form-group>
          <b-row class="text-left" no-gutters>
            <b-col cols="12" md="6">
              <b-button
                :disabled="!isSamePassword()"
                type="submit"
                variant="primary-b"
                size="xl"
              >{{ $t('register.submit_button') }}</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import PasswordInput from "@/components/PasswordInput";
import PasswordHelper from "@/components/PasswordHelper";

export default {
  name: "register-form",
  components: {
    PasswordInput,
    PasswordHelper,
  },
  data() {
    return {
      show_pass_helper: false,
      show_same_pass_helper: false,
      isRegisterError: false,
      form: {
        username: "",
        email: "",
        password: "",
        password2: "",
        checked: [],
      },
      form_invalid_feedback: {
        username: undefined,
        email: undefined,
        password: undefined,
      },
      form_state: {
        username: undefined,
        email: undefined,
        password: undefined,
      },
      form_valid: false,
      show: true,
    };
  },
  fallbackI18n: {
    messages: {
      und: {
        register: {
          email: "Email",
          username: "Username",
          password: "Password",
          password2: "Repeat password",
          login_link: "Back to login",
          password_label: "Password:",
          submit_button: "Register",
          register_error_feedback: "Please correct the problems of the form",
          terms: "I accept the terms and use",
          private: "I agree privacy policy",
          pass_validator_help_same_password: "Passwords do not match.",
        },
      },
    },
  },
  methods: {
    handleOnFocusPassInput() {
      this.show_pass_helper = true;
    },
    handleOnFocusPass2Input() {
      this.show_same_pass_helper = true;
    },
    isSamePassword: function() {
      var isSamePassword = false;
      if (this.form.password != "") {
        isSamePassword = this.form.password == this.form.password2;
      }
      return isSamePassword;
    },
    doSubmit(evt) {
      this.isRegisterError = false;
      evt.preventDefault();
      this.$recaptcha("register_form").then(
        token => {
          this.$store.dispatch("auth/REGISTER", {
            ...this.form,
            recaptcha_token: String(token),
          }).then(
            () => {
              this.$router.push({
                name: "register-login",
              });
            },
            err => {
              this.showResponseError(err);
              this.putFormFeedback(err.response);
            }
          );
        },
        err => {
          this.$sentry({ capture: err });
          this.showResponseError(err);
          this.putFormFeedback(err.response);
        }
      );
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.checked = [];
      this.disable_btn = true;
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>


<style lang="scss" scoped>
.text-info {
  color: red !important;
}
</style>
